import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    error: (name: string) => string | React.ReactNode;
    success: (name: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error toast message when sending invitation fails */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "useSendInviteEmail.error?c=2aehx1hju0bhq", defaultMessage: "There was an issue sending a new invitation to {name}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success toast message when invitation is sent */
            success: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "useSendInviteEmail.success?c=1co6umlouvdny", defaultMessage: "{name} was invited again" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
